import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { Video, HelpService } from './help.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  videos: Video[] = [];
  loading = true;

  constructor(
    private sanitizer: DomSanitizer,
    private helpService: HelpService
  ) { }

  ngOnInit(): void {
    this.helpService
      .tutorial()
      .subscribe({
        next: videos => {
          this.loading = false;
          this.videos = videos;
        },
        error: () => { this.loading = false; },
      });
  }

}
